import { createSlice } from "@reduxjs/toolkit";

import { getCompany, getCompanyTypes, updateCompany } from "./actions";
import { Company } from "./types";

export interface CompanyState {
  error: any;
  data: Company | null;
  loading: boolean;
  companyTypes: { label: string; value: string }[];
}

const initialState: CompanyState = {
  loading: false,
  data: null,
  error: false,
  companyTypes: [],
};

export const companySlice = createSlice({
  initialState,
  name: "company",
  reducers: {},
  extraReducers: (builder) => {
    // UPDATE COMPANY
    builder.addCase(updateCompany.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateCompany.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(updateCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      state.error = false;
    });
    // GET COMPANY
    builder.addCase(getCompany.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getCompany.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getCompany.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      state.error = false;
    });
    builder.addCase(getCompanyTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getCompanyTypes.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getCompanyTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.companyTypes = action.payload.data;
      state.error = false;
    });
  },
});

// Action creators are generated for each case reducer function
// eslint-disable-next-line
export const {} = companySlice.actions;
export default companySlice.reducer;
